import PropTypes from "prop-types";
import {Bar} from 'react-chartjs-2';
import checkFloat from "../../assets/helpers/checkFloat";

const SingleVerticalBarChart = (props) =>{

    const { label, Data, dLabel,onChartClick,width,height,yLabel,xLabel,xTick,yTick} = props;

    const chartData = {
            labels: label,
            datasets: [
                {
                    label: dLabel,
                    data: Data,
                    backgroundColor:  '#5FBEFB',
                }
            ]
    }

    const datasetKeyProvider=()=>{
        return btoa(Math.random()).substring(0,12)
    }

    const handleClick = (element) =>{
        if(props.onChartClick && element[0]){
            onChartClick(element);
        }
    }
    
    const defaultOptions = {
       
        maintainAspectRatio: true,
        
        onHover: (event, chartElement) => {
            event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
        
        scales: {
            xAxes: [{
                stacked: true,
                barPercentage:0.2,
                gridLines: {
                    drawBorder: true,
                    drawOnChartArea: false
                }, ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        if(value>999)
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ (xTick?xTick:'');
                        else if(checkFloat(value))
                            return value.toFixed(1)+(xTick?xTick:'');
                        else
                            return value+(xTick?xTick:'');
                    }
                },
                scaleLabel: {
                display: xLabel? true:false,
                labelString: xLabel
                }
            }],
            yAxes: [{
                stacked: true,
                barPercentage:0.4,
                gridLines: {
                    drawBorder: true,
                    drawOnChartArea: false
                },
                ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        if(value>999)
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ (yTick?yTick:'');
                        else if(checkFloat(value))
                            return value.toFixed(1)+(yTick?yTick:'');
                        else
                            return value+(yTick?yTick:'');
                    }
                },
                scaleLabel: {
                    display: yLabel? true:false,
                    labelString: yLabel
                }
            }]
        }
    };

    return(
        <div>
            <Bar
            data={chartData}
            width={width?width:400}
            height={height?height:250}
            options= {defaultOptions}
            datasetKeyProvider={datasetKeyProvider}
            onElementsClick={handleClick}
            />
        </div>
    )
}

SingleVerticalBarChart.propTypes ={
    label : PropTypes.array,
    Data : PropTypes.array,
    dLabel :PropTypes.string,
    onChartClick :PropTypes.func,
    width : PropTypes.number,
    height : PropTypes.number,
    yLabel: PropTypes.string,
    xLabel: PropTypes.string,
}
export default SingleVerticalBarChart;
